import _ from "lodash";

export function stringifyQueryParams(params) {
  return _.toPairs(params)
    .map(pair => pair.join("="))
    .join("&");
}
